import React, { useState } from 'react';
import { Col, Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import RepresentativeDTO from '../../../../dto/RepresentativeDTO';
import Switches from '../../../../components/fields/Switches/Switches';
import FileInput from '../../../../components/fields/FileInput/FileInput';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import FIOForm from './FIOForm';
import AccordionWithPreview from '../../../../components/base/Accordion/AccordionWithPreview';
import AddressInput from '../../../../components/fields/Address/AddressInput';
import AutoAcceptRepresentative from '../AutoAcceptRepresentative';

export default function RepresentativeForm(props) {
  const {
    prefix = 'representative.',
    disabled,
    control,
    currentApplication,
    formMeta,
    setToggleRepresentative = () => {},
    setValue = () => {},
    getValues = () => {},
  } = props;
  const [representative, setRepresentative] = useState(currentApplication && currentApplication?.representative);
  const dto = new RepresentativeDTO();
  const attributes = dto.getAttributesByName();

  function renderFullRepresentativeForm() {
    return (
      <>
        <Row className="row-cols-1">
          <AutoAcceptRepresentative
            setValue={setValue}
            control={control}
            getValues={getValues}
            prefix={prefix}
          />
          {/* <FieldDTOWithCol */}
          {/*  control={control} */}
          {/*  formMeta={formMeta} */}
          {/*  type="text" */}
          {/*  component={TextInputWithLabel} */}
          {/*  dtoObject={attributes.representative_name} */}
          {/*  variant="material" */}
          {/*  namePrefix={prefix} */}
          {/*  disabled={disabled} */}
          {/* /> */}
        </Row>
        <FIOForm {...props} />
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.organization_name}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.inn}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={AddressInput}
            dtoObject={attributes.address}
            variant="material"
            namePrefix={prefix}
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.phone}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.email}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={FileInput}
            dtoObject={attributes.representative_identity_files}
            variant="material"
            namePrefix="media."
            disabled={disabled}
            multiple
          />
        </Row>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.document_of_authority_number}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            withLabel
            dtoObject={attributes.document_of_authority_issue_date}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
        </Row>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            withLabel
            dtoObject={attributes.document_of_authority_expiration_date}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={FileInput}
            dtoObject={attributes.representative_document_scan}
            variant="material"
            namePrefix="media."
            disabled={disabled}
            multiple
          />
        </Row>
      </>
    );
  }

  function renderPreviewRepresentativeForm() {
    return (
      <>
        <Row className="row-cols-1">
          <AutoAcceptRepresentative
            setValue={setValue}
            control={control}
            getValues={getValues}
            prefix={prefix}
          />
          {/* <FieldDTOWithCol */}
          {/*  control={control} */}
          {/*  formMeta={formMeta} */}
          {/*  type="text" */}
          {/*  component={TextInputWithLabel} */}
          {/*  dtoObject={attributes.representative_name} */}
          {/*  variant="material" */}
          {/*  namePrefix={prefix} */}
          {/*  disabled={disabled} */}
          {/* /> */}
        </Row>
        <FIOForm {...props} />
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.organization_name}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.inn}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.phone}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.email}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={FileInput}
            dtoObject={attributes.representative_identity_files}
            variant="material"
            namePrefix="media."
            disabled={disabled}
            multiple
          />
        </Row>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.document_of_authority_number}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            withLabel
            dtoObject={attributes.document_of_authority_issue_date}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
        </Row>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            withLabel
            dtoObject={attributes.document_of_authority_expiration_date}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={FileInput}
            dtoObject={attributes.representative_document_scan}
            variant="material"
            namePrefix="media."
            disabled={disabled}
            multiple
          />
        </Row>
      </>
    );
  }

  return (
    <>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => { setRepresentative(!representative); setToggleRepresentative(!representative); },
              value: representative,
            }}
            label="С представителем"
          />
        </Col>
      </Row>
      {representative ? (
        <AccordionWithPreview
          title="Представитель"
          required={renderPreviewRepresentativeForm()}
          content={renderFullRepresentativeForm()}
        />
      ) : null}
    </>
  );
}
